import * as React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { GlobalUseStyles } from './GlobalUseStyles';
import clsx from 'clsx';
import { PDMLogin } from './RestService';
import { useMsal } from '@azure/msal-react';   
import { snackbar } from "../snackbarService";
import ErrorIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({

}));

export default function PDMSignIn(props) {
const classes = useStyles();
const globalClasses = GlobalUseStyles();
const { instance, accounts } = useMsal();
 
const generateRandomString = (input) => {
  const maxLength = 16;
  
  const predefinedChars = 'KONECWSWEBAPPUSR';
  
  let result = input.slice(0, maxLength);

  let i = 0;
  while (result.length < maxLength) {
    result += predefinedChars[i % predefinedChars.length];
    i++;
  }

  return result;
};

const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    var formData = {};
    data.forEach(function(value, key){
      formData[key] = value;
    });  
    formData['username'] = formData['username'].toLowerCase();  
    sessionStorage.setItem("pdmUsername", formData['username']);
    sessionStorage.setItem("pdmPassword", formData['password']);
        
    console.log("Call login check");
    loginCheck(formData);
};

    // Test query to PDM to confirm that user info is correct. If is correct, set session storage parameters.    
    const loginCheck = async (formData) => {
      console.log("PDM Login initiated");
      snackbar.success("Authenticating...",300000)
      let loginReply = await PDMLogin(instance);
      console.log(loginReply);
      if (loginReply.reply == formData['username'] || loginReply.reply == accounts[0].username)
      {
        props.setPdmUsername(formData['username']);
        console.log("Login was successful");
        sessionStorage.setItem("pdmLoginFailed", "false");
        sessionStorage.setItem("pdmPassword", loginReply.code);
        snackbar.close();
      }
      else
      {
        sessionStorage.setItem("pdmUsername", "");
        sessionStorage.setItem("pdmPassword", "");
        if(loginReply.reply==null || loginReply.reply=="")
        {
          loginReply="Login failed : PDM unreachable.";
        }
        console.log("Login failed:", loginReply.reply)
        sessionStorage.setItem("pdmLoginFailed", "true");
        snackbar.warning(loginReply,300000)
      }
    }; 

return (
  <Container component="main" maxWidth="xs">
    <CssBaseline />
    <Box style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh"}}>
      {/* <Avatar>
        <LockOutlinedIcon />
      </Avatar> */}
      <Typography component="h1" variant="h5">
        PDM Sign in
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label="KONE ID"
          name="username"
          autoComplete="username"
          autoFocus
          inputProps={{ style: { textTransform: "lowercase" } }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        {/* <FormControlLabel
          control={<Checkbox value="remember" color="primary" />}
          label="Remember me"
        /> */}
        <Button
          style={{marginTop: "18px"}}
          type="submit"
          fullWidth
          variant="contained"
          className={clsx(globalClasses.blueButton)}
        >
          Sign In
        </Button>
        {/* <Grid container>
          <Grid item xs>
            <Link href="#" variant="body2">
              Forgot password?
            </Link>
          </Grid>
          <Grid item>
            <Link href="#" variant="body2">
              {"Don't have an account? Sign Up"}
            </Link>
          </Grid>
        </Grid> */}
      </Box>
    </Box>
  </Container>
);
}